module.exports = __webpack_public_path__ + "img/noti-cancel.bfcf9175.svg";